import type { SituationSortSituation } from '../types';

const LEADING_PICTO_RE = /^\p{Extended_Pictographic}+\s*/u;

export function getSituationSortDisplayLabel(
  situation: Pick<SituationSortSituation, 'label'>,
  index: number
): string {
  const custom = situation.label?.trim();
  return custom || `Situation ${index + 1}`;
}

/** Retire l'emoji de tête d'un libellé de catégorie (la charte le remplace par un trait). */
export function stripLeadingPictographs(label: string): string {
  return label.replace(LEADING_PICTO_RE, '');
}

/** Nom nu d'une catégorie, pour le verdict : sans picto, sans gras, sans glose. */
export function categoryDisplayName(label: string): string {
  return stripLeadingPictographs(label)
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\([^)]*\)\s*$/, '')
    .trim();
}

export function situationSortVerdict(ok: boolean, expectedLabel: string): string {
  return ok ? 'bien classée' : `à ranger dans « ${categoryDisplayName(expectedLabel)} »`;
}

/**
 * Mélange Fisher–Yates, rebrassé tant que plus d'une carte est restée en place.
 * Un mélange simple laisse trop souvent la première carte en tête.
 */
export function shuffleSituations<T>(items: T[]): T[] {
  if (items.length <= 1) return [...items];

  const brasse = (source: T[]): T[] => {
    const next = source.slice();
    for (let i = next.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = next[i]!;
      next[i] = next[j]!;
      next[j] = tmp;
    }
    return next;
  };

  let ordered = items;
  let tries = 0;
  do {
    ordered = brasse(items);
    tries += 1;
  } while (ordered.filter((item, index) => item === items[index]).length > 1 && tries < 40);

  return ordered;
}
